import { BsCalendar2Date } from "react-icons/bs";
import { PiExam } from "react-icons/pi";
import { MdDashboard } from "react-icons/md";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { pageTitle } from "../../../../../store/softSlice";
import { LiaClipboardListSolid } from "react-icons/lia";

const OnlyTeacherDashboardView = ({ PageTitle, setIconsButton }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(pageTitle({ title: PageTitle }));
    document.title = `${PageTitle}`;
    setIconsButton(null);
  }, []);

  // Sidebar menu items
  const menuItems = [
    {
      to: "/subj-student-attendance-create-list-view",
      icon: <BsCalendar2Date size={22} />,
      label: "Attendance",
    },
    {
      to: "/student-attendance-report-list-view",
      icon: <LiaClipboardListSolid size={22} />,
      label: "Attendance Report",
    },
    {
      to: "/single-subject-marks-enter-create-list-view",
      icon: <PiExam size={22} />,
      label: "Marks Entry",
    },
    {
      to: "/dashboard",
      icon: <MdDashboard size={22} />,
      label: "Dashboard",
    },
    {
      to: "/logout",
      icon: <RiLogoutBoxRLine size={22} />,
      label: "Logout",
    },
  ];

  return (
    <div>
      <div className="w-20 bg-slate700 text-white flex flex-col items-center py-6 space-y-6 rounded-tr-xl rounded-br-xl fixed shadow-md">
        {menuItems.map((item, index) => {
          const isActive = location.pathname === item.to;
          return (
            <Link key={index} to={item.to} className="group relative">
              <div
                className={`flex flex-col items-center transition-all duration-150 ${
                  isActive
                    ? "text-yellow-400"
                    : "text-white group-hover:text-yellow-300"
                }`}
              >
                {item.icon}
                <span className="text-[10px] mt-1 text-center">{item.label}</span>
              </div>

              {/* Tooltip on hover */}
              <span className="absolute left-20 top-1/2 -translate-y-1/2 scale-0 group-hover:scale-100 transition-all origin-left bg-gray-900 text-white text-xs px-2 py-1 rounded shadow-md z-10 whitespace-nowrap">
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default OnlyTeacherDashboardView;
